<template>
  <div class="invoice__details">
    <!-- Return Sales New Data Add -->
    <div class="vx-row pt-5 px-5">
      <div class="vx-col w-full lg:w-5/12 md:w-1/2">
        <div class="vx-row mb-2">
          <div class="vx-col w-2/5 text-right">
            <h6>Sales Code</h6>
          </div>
          <div class="vx-col w-3/5">
            <h6>{{ saleDetails && saleDetails.sales_code }}</h6>
          </div>
        </div>
        <div class="vx-row mb-2 items-center">
          <div class="vx-col w-2/5 text-right">
            <h6>Date</h6>
          </div>
          <div class="vx-col w-3/5 relative">
            <date-picker
              v-if="saleDetails"
              :appendToBody="false"
              v-model="saleDetails.sales_return_date"
              placeholder="MM-DD-YYYY"
              v-validate="'required'"
              format="MM-DD-YYYY"
              valueType="format"
              class="w-full"
              name="Sales Return Date"
            />
          </div>
        </div>
      </div>
      <div class="vx-col w-full lg:w-5/12 md:w-1/2">
        <div class="vx-row mb-2">
          <div class="vx-col w-2/5 text-right">
            <h6>Customer Name</h6>
          </div>
          <div class="vx-col w-3/5">
            <h6>{{ saleDetails && saleDetails.customer.business_name }}</h6>
          </div>
        </div>
      </div>
    </div>
    <!-- End Return Sales New Data Add -->

    <hr class="mt-5 border border-black" />
  </div>
</template>

<script>
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'

export default {
  name: 'InvoiceDetails',

  // props
  props: {
    saleDetails: Object
  },

  data() {
    return {
      date: 'MM-dd-yyyy'
    }
  },

  components: {
    DatePicker
  }
}
</script>

<style></style>
